<template>
  <div class="dnd-container">
    <form enctype="multipart/form-data" novalidate>
      <div class="dropbox">
        <input type="file" multiple accept="image/*" class="input-file">
          <p class="file_drop_msg">{{ LANG.dropYourFilesHereToStartUploading }}</p>
          <p class="file_drop_warning">
            <i class="fa5 fas fa-info-circle fas" name="info-circle"></i>
            {{ LANG.thinkTwiceBeforeUploadingBigFiles }}
          </p>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['LANG']),
  },
};
</script>

<style scoped lang='scss'>
.dnd-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background: rgba(255,255,255, 0.9);

  form {
    width: 100%;
    height: 100%;

    .dropbox {
      border: 2px dotted #ccc;
      height: 55%;
      margin: 15% 12%;
      padding: 0;
      position: relative;
      background: url(/imperia/images/undraw/file_upload.svg) no-repeat;
      background-color: rgba(255,255,255, 0.7);
      background-size: auto 54%;
      background-position: center 35%;
      transition: 0.3s ease-in;

      input {
        display: none;
      }

      .file_drop_msg {
        width: 100%;
        text-align: center;
        font-size: 16px;
        font-family: "Roboto Regular";
        font-weight: normal;
        position: absolute;
        bottom: 5%;
      }

      .file_drop_warning {
        font-family: "Roboto Light";
        font-size: 14px;
        position: absolute;
        bottom: -50px;
        left: 0;
      }
    }
  }
}
</style>
